<template>
  <div  class="product imgTOP-current header-90">
      <div  class="top-img">
        <img class="mobile_hide" src="../assets/images/product-banner.png" alt="">
        <div class="info-box">
          <div class="title-box">
            <h2>{{nameEN}}</h2>
            <h3 v-if="$i18n.locale!='en'">{{name}}</h3>
          </div>
          <div class="bannerImage">
            <img :src="bannerImage" alt="">
          </div>
        </div>
      </div>
    <div class="product-main">
      <div class="product-conten">
        <div class="product-title">
          <router-link to="/home">{{$t("home_0")}}</router-link>
          <em>/</em>
          <span>{{name}}</span>
        </div>
        <div class="nav mobile_hide">
          <h4  :class="{'en-font-28':locale=='EN'}">{{$t('home_1')}}</h4>
          <ul>
            <li v-for="(item,index) in typeList" :key="index" @click="tabtitle(item.id, item.name, item.bannerImage)" :class="{ active: paramId == item.id }" class="box">
              <a :class="{'en-font-18':locale=='EN'}">{{item.name}}(<span>{{ item.count }}</span>)</a><em class="nav-line"></em>
            </li>
          </ul>
        </div>
        <div class="type-nav pc_hide" v-if="typeList.length > 0">
          <vue-tab-select v-model="paramId" :list="typeList" :title="'home_1'" :keyName="'id'" @valueChanged="changeType"></vue-tab-select>
        </div>
        <div class="product-show">
          
          <div class="description" >
            <h1>{{ descriptionTitle }}</h1>
            <h2 style="font-size:18px;">{{ descriptionSubtitle }}</h2>
            <div style="margin-bottom: 20px;"></div>   <!--控一行 -->
            <h2>{{ descriptionContent }}</h2>
          </div>

         <div style="margin-bottom: 20px;"></div>
                 
          <ul>
            <li v-for="(item,index) in productList" @click="toDetail(item.id)" :key="index">
              <div class="img-box">
                <div class="big-img-box">
                  <img :src="item.maxImage" :alt="item.name">
                </div>
                <div class="small-img-box mobile_hide" v-if="item.minImage">
                  <img :src="item.minImage" :alt="item.name">
                </div>
              </div>
              <p>{{ item.name }}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import API from "./config/api";
  import vueTabSelect from "./default/vue-tab-select";
  export default {
    name: 'Product',
    data () {
      return {
        name:'',
        nameEN:'',
        paramId: '',
        typeList: [],
        productList: [],
        bannerImage: '',
        locale:'tw',
        descriptionTitle: '', // 鍋貼系列之類的 h1
        descriptionSubtitle: '', // 鍋貼系列之類的 h2
        descriptionContent: '', // 鍋貼系列之類的 h2
       staticProductData: {
          '0201': [
            {"id": "a4ff6732-ccef-4e3d-e086-08d8b6c72caa", "maxImage": "https://www.8way.com.tw/8WayApi/document/aba97afe-d70f-4613-ab90-f6e123742a1d.png", "minImage": "https://www.8way.com.tw/8WayApi/document/964a6d01-c641-4262-9c57-cb60c85d2d0c.png", "name": "招牌鍋貼"},
            {"id": "3a4d1540-6ffc-4252-5f7c-08d8b6c8a685", "maxImage": "https://www.8way.com.tw/8WayApi/document/76b5d0b4-f775-41c6-ad56-0ec2dd8c1756.jpg", "minImage": "https://www.8way.com.tw/8WayApi/document/67b6bcd1-a274-400f-89dd-96b2a35f0b8c.png", "name": "韭菜鍋貼"},
            {"id": "9bcf48c3-627d-4995-5f7d-08d8b6c8a685", "maxImage": "https://www.8way.com.tw/8WayApi/document/c54dd0cb-68f1-44ea-b622-e7e434cdcc67.png", "minImage": "https://www.8way.com.tw/8WayApi/document/bd36c974-0f74-40fb-a105-f0641d190cab.png", "name": "韓式辣味鍋貼"},
            {"id": "9bcf48c3-627d-4995-5f7d-08d8b6c8a686", "maxImage": "https://www.8way.com.tw/8WayApi/document/8e172086-8276-43c2-a1f0-da947e7b3848.png", "minImage": "https://www.8way.com.tw/8WayApi/document/351c1db2-b650-445b-9ad3-b1fc8f47b6ae.png", "name": "玉米鍋貼"},
            {"id": "9bcf48c3-627d-4995-5f7d-08d8b6c8a687", "maxImage": "https://www.8way.com.tw/8WayApi/document/93c8b3c0-75af-48d7-9480-319e73461fd6.jpg", "minImage": "https://www.8way.com.tw/8WayApi/document/c6d70dd7-8552-44d1-aa83-e1927bb03f56.png", "name": "咖哩鍋貼"},
            {"id": "9bcf48c3-627d-4995-5f7d-08d8b6c8a689", "maxImage": "https://www.8way.com.tw/8WayApi/document/0b02cbe6-ead5-4db2-8c84-3ec3d3aea222.png", "minImage": "https://www.8way.com.tw/8WayApi/document/6c670594-f6f8-4fc7-9189-d158db575d7e.jpg", "name": "新蔬食鍋貼"}
          ],
          '0202': [
            {"id": "6e1818ee-4624-43fe-81b6-08d8b7af8f3e", "maxImage": "https://www.8way.com.tw/8WayApi/document/e4f2a13f-0c85-4d35-8562-7fd728ad95e2.png", "minImage": "https://www.8way.com.tw/8WayApi/document/0a285348-db14-45c6-a0e0-5f3a580deb92.png", "name": "招牌水餃"},
            {"id": "ce48b35e-0178-4404-c08d-08d8b7b843f1", "maxImage": "https://www.8way.com.tw/8WayApi/document/69fdb291-f4a8-4667-952e-4f6821d4947a.png", "minImage": "https://www.8way.com.tw/8WayApi/document/e0333640-7c5a-405b-a266-c36c6a824be1.png", "name": "韭菜水餃"},
            {"id": "ce48b35e-0178-4404-c08d-08d8b7b843f2", "maxImage": "https://www.8way.com.tw/8WayApi/document/a79c42cc-806c-4770-bb0b-3a82f0db4b40.png", "minImage": "https://www.8way.com.tw/8WayApi/document/5b3ad532-26fa-4b0d-911b-130fc298f371.png", "name": "韓式辣味水餃"},
            {"id": "ce48b35e-0178-4404-c08d-08d8b7b843f3", "maxImage": "https://www.8way.com.tw/8WayApi/document/4d8d2aaf-5a46-4613-aaeb-8cd39f858622.png", "minImage": "https://www.8way.com.tw/8WayApi/document/1b2f4966-f1c9-4ec7-9107-7cfe1979c191.png", "name": "玉米水餃"},
            {"id": "ce48b35e-0178-4404-c08d-08d8b7b843f4", "maxImage": "https://www.8way.com.tw/8WayApi/document/1fcf524d-8b67-41c2-a43a-909dacebcae4.png", "minImage": "https://www.8way.com.tw/8WayApi/document/19845d5a-c2ef-48c6-ab2e-562de85692a6.png", "name": "咖哩水餃"},
            {"id": "ce48b35e-0178-4404-c08d-08d8b7b843ff", "maxImage": "https://www.8way.com.tw/8WayApi/document/318a7a32-2c27-413d-b6a2-80f43dedbe83.png", "minImage": "https://www.8way.com.tw/8WayApi/document/d3066263-19df-40f9-a2f6-24222264e5be.png", "name": "鮮蝦水餃"},
            {"id": "61b64468-2422-4572-62b8-08d8b7cf081d", "maxImage": "https://www.8way.com.tw/8WayApi/document/a2d1e394-4b82-4f81-a8c3-a8db054cc73b.png", "minImage": "https://www.8way.com.tw/8WayApi/document/e47248d6-205a-4490-b166-63d350ccdf33.jpg", "name": "新蔬食水餃"}
          ],
          '0204': [
            {"id": "ce48b35e-0178-4404-c08d-08d8b7b80401", "maxImage": "https://www.8way.com.tw/8WayApi/document/325585b8-e8e9-4ca5-b835-203c29175852.png", "minImage": null, "name": "古早味乾麵"},
            {"id": "ce48b35e-0178-4404-c08d-08d8b7b80402", "maxImage": "https://www.8way.com.tw/8WayApi/document/d19337e3-4f73-496f-bbfe-7ec02cd916cb.png", "minImage": null, "name": "招牌乾麵"},
            {"id": "ce48b35e-0178-4404-c08d-08d8b7b80403", "maxImage": "https://www.8way.com.tw/8WayApi/document/5d1a9a9a-a096-492d-8f6e-9499f61dff44.png", "minImage": null, "name": "麻醬乾麵"},
            {"id": "ce48b35e-0178-4404-c08d-08d8b7b80404", "maxImage": "https://www.8way.com.tw/8WayApi/document/fda3897f-ab29-4360-9a6a-354114bfe6e0.png", "minImage": null, "name": "紹辣乾麵"}
          ],
          '0205': [
            {"id": "03550391-0ab7-44bd-7cc8-08de2678fb9d", "maxImage": "https://www.8way.com.tw/8WayApi/document/2a7ccdc2-471e-4dcf-bf58-9d9d13ba1ca5.png", "minImage": null, "name": "梁師傅排骨麵"},
            {"id": "ce48b35e-0178-4404-c08d-08d8b7b80506", "maxImage": "https://www.8way.com.tw/8WayApi/document/d7b85591-57b7-42b2-acf4-fae777fe2489.png", "minImage": null, "name": "紹辣珍珠餛飩麵"},
            {"id": "ce48b35e-0178-4404-c08d-08d8b7b80507", "maxImage": "https://www.8way.com.tw/8WayApi/document/59cc15cd-bde6-490a-9d33-edbc662dd5a7.png", "minImage": null, "name": "紹辣菜肉大餛飩麵"},
            {"id": "ce48b35e-0178-4404-c08d-08d8b7b80505", "maxImage": "https://www.8way.com.tw/8WayApi/document/d57616e3-fe9f-44fc-8f41-925e540dba03.png", "minImage": null, "name": "菜肉大餛飩麵"},
            {"id": "ce48b35e-0178-4404-c08d-08d8b7b80504", "maxImage": "https://www.8way.com.tw/8WayApi/document/6fd19f67-1e52-4d79-9087-907e256f4be1.png", "minImage": null, "name": "珍珠餛飩麵"},
            {"id": "ce48b35e-0178-4404-c08d-08d8b7b80503", "maxImage": "https://www.8way.com.tw/8WayApi/document/e1f73c2d-0364-42a1-8362-c4d9ca16bea7.png", "minImage": null, "name": "榨菜肉絲麵"},
            {"id": "ce48b35e-0178-4404-c08d-08d8b7b80502", "maxImage": "https://www.8way.com.tw/8WayApi/document/c57ebb05-72a7-4596-b255-ffc3c720a80f.png", "minImage": null, "name": "酸辣湯麵"},
            {"id": "ce48b35e-0178-4404-c08d-08d8b7b80501", "maxImage": "https://www.8way.com.tw/8WayApi/document/1dfc13ed-4df7-4eb8-ad58-9549c31e67aa.png", "minImage": null, "name": "古早味湯麵"}
          ],
          '0212': [
            {"id": "4715d2d0-bd14-47ed-df86-08db9241b894", "maxImage": "https://www.8way.com.tw/8WayApi/document/33517e23-0814-4d54-8a2c-faacbd2d6e30.png", "minImage": null, "name": "紅燒牛肉麵"},
            {"id": "66e3f4e9-1d4c-4b76-f391-08db923ed5a0", "maxImage": "https://www.8way.com.tw/8WayApi/document/7906d3e5-efd4-492b-983c-da54d6a6dc87.png", "minImage": null, "name": "清燉牛肉麵"},
            {"id": "1a135f8a-3cc7-4dd6-df87-08db9241b894", "maxImage": "https://www.8way.com.tw/8WayApi/document/a2b2398d-21b5-42a0-80d0-95571b64d574.png", "minImage": null, "name": "麻辣牛肉麵"},
            {"id": "37b3528e-4144-4161-986b-08dcf1a97507", "maxImage": "https://www.8way.com.tw/8WayApi/document/2f30f51a-d5bc-404b-b88e-fbae2f7cfea9.png", "minImage": null, "name": "紅燒牛肉冬粉(部分門市)"},
            {"id": "c9e36ad1-2755-4435-986c-08dcf1a97507", "maxImage": "https://www.8way.com.tw/8WayApi/document/fb14513c-9ea3-49cf-9579-0050af2a1b8a.png", "minImage": null, "name": "清燉牛肉冬粉(部分門市)"},
            {"id": "64790dd2-2ad6-4b6b-986d-08dcf1a97507", "maxImage": "https://www.8way.com.tw/8WayApi/document/c051cd79-61ff-4066-89ff-d92c87d4df61.png", "minImage": null, "name": "麻辣牛肉冬粉(部分門市)"},
            {"id": "33a735be-a142-40e1-2e4b-08dbc3e43c56", "maxImage": "https://www.8way.com.tw/8WayApi/document/47f65eef-6c86-4f5e-ae1a-bfbdff499234.jpg", "minImage": null, "name": "紅燒牛湯餃"},
            {"id": "10cc2dfb-1a01-4c63-2e4c-08dbc3e43c56", "maxImage": "https://www.8way.com.tw/8WayApi/document/76242c00-af04-4bb5-9b30-bccf4e06feb0.jpg", "minImage": null, "name": "麻辣牛湯餃"},
            {"id": "36c7a2f6-118c-4b23-2e4d-08dbc3e43c56", "maxImage": "https://www.8way.com.tw/8WayApi/document/59cf6bd6-8abe-478b-badc-a01d03eea042.jpg", "minImage": null, "name": "紅燒牛湯珍珠餛飩"},
            {"id": "994903ea-51d4-4e68-2e4e-08dbc3e43c56", "maxImage": "https://www.8way.com.tw/8WayApi/document/213faeb6-1324-4fcd-8a07-3ceae7126db2.jpg", "minImage": null, "name": "麻辣牛湯珍珠餛飩"},
            {"id": "2107d249-d76b-41e7-2e4f-08dbc3e43c56", "maxImage": "https://www.8way.com.tw/8WayApi/document/02fa7803-6889-441e-bd73-6917e378cf7d.jpg", "minImage": null, "name": "紅燒牛湯菜肉大餛飩"},
            {"id": "24d50425-831f-4eae-913b-08dbc3f38768", "maxImage": "https://www.8way.com.tw/8WayApi/document/458831d3-9442-4aef-bf43-c2f9507d0045.jpg", "minImage": null, "name": "麻辣牛湯菜肉大餛飩"}
          ],
          '0206': [
            {"id": "ce48b35e-0178-4404-c08d-08d8b7b80601", "maxImage": "https://www.8way.com.tw/8WayApi/document/9e0364c0-dfc5-45c6-ada6-3693d233055c.jpg", "minImage": null, "name": "酸辣湯"},
            {"id": "ce48b35e-0178-4404-c08d-08d8b7b80602", "maxImage": "https://www.8way.com.tw/8WayApi/document/6199cc3c-76c9-4dda-9d7c-2d47221d169d.png", "minImage": null, "name": "玉米濃湯"},
            {"id": "ce48b35e-0178-4404-c08d-08d8b7b80604", "maxImage": "https://www.8way.com.tw/8WayApi/document/de53559c-be4d-41a9-b3f7-5fece1b85d67.png", "minImage": null, "name": "蘿蔔湯"},
            {"id": "ce48b35e-0178-4404-c08d-08d8b7b80605", "maxImage": "https://www.8way.com.tw/8WayApi/document/180f7443-cdd6-4a0f-b71c-df29ea94b993.png", "minImage": null, "name": "旗魚花枝丸湯"},
            {"id": "ce48b35e-0178-4404-c08d-08d8b7b80606", "maxImage": "https://www.8way.com.tw/8WayApi/document/47812fe7-e9ac-4e57-b880-8de69d67d94e.jpg", "minImage": null, "name": "珍珠餛飩湯"},
            {"id": "ce48b35e-0178-4404-c08d-08d8b7b80607", "maxImage": "https://www.8way.com.tw/8WayApi/document/c63e91cb-c183-410a-8016-102ef8cbb106.png", "minImage": null, "name": "菜肉大餛飩湯"}
          ],
          '0207': [
            {"id": "dac128e2-c08e-4210-d078-08d8de1a25a1", "maxImage": "https://www.8way.com.tw/8WayApi/document/17b1ca45-0ba4-48e5-8a1c-e63068b7e80b.png", "minImage": null, "name": "酸辣湯餃"},
            {"id": "da31ea27-b514-48f5-d079-08d8de1a25a1", "maxImage": "https://www.8way.com.tw/8WayApi/document/f999f1df-190f-4d3d-ab8a-e870647609e5.png", "minImage": null, "name": "玉米湯餃"}
          ],
          '0208': [
            {"id": "ce48b35e-0178-4404-c08d-08d8b7b81003", "maxImage": "https://www.8way.com.tw/8WayApi/document/a4bc3a79-f213-4465-9160-7e306001a363.png", "minImage": null, "name": "珍珠和風抄手"},
            {"id": "ce48b35e-0178-4404-c08d-08d8b7b81004", "maxImage": "https://www.8way.com.tw/8WayApi/document/feca678b-f750-4f87-9489-dc331596d28c.png", "minImage": null, "name": "珍珠紅油抄手"},
            {"id": "ce48b35e-0178-4404-c08d-08d8b7b81001", "maxImage": "https://www.8way.com.tw/8WayApi/document/09c9b5e9-6334-4258-8537-345aaef08863.png", "minImage": null, "name": "菜肉和風大抄手"},
            {"id": "ce48b35e-0178-4404-c08d-08d8b7b81002", "maxImage": "https://www.8way.com.tw/8WayApi/document/ccd39444-a24d-41ef-aa62-6d5c8788e082.png", "minImage": null, "name": "菜肉紅油大抄手"}
          ],
          '0209': [
            {"id": "f2a1900a-e7fa-4327-2d7c-08dd0e7ed0fe", "maxImage": "https://www.8way.com.tw/8WayApi/document/186709d8-d4f5-4453-8c4d-535a96127934.png", "minImage": null, "name": "蠔油涼拌豆腐"},
            {"id": "4102fa7b-3531-4be9-2d7d-08dd0e7ed0fe", "maxImage": "https://www.8way.com.tw/8WayApi/document/7e10161c-494b-48d8-9f81-462ca88c250a.png", "minImage": null, "name": "麻醬涼拌豆腐"},
            {"id": "e0b30ac7-033c-47b8-2d7e-08dd0e7ed0fe", "maxImage": "https://www.8way.com.tw/8WayApi/document/4707581f-5dce-4371-98b0-26f6346b44a8.png", "minImage": null, "name": "紅油涼拌豆腐"},
            {"id": "a2d138c3-465f-452d-7cc6-08de2678fb9d", "maxImage": "https://www.8way.com.tw/8WayApi/document/ddb0ce49-b05c-41ee-a822-bcf75a3fe5a6.jpg", "minImage": null, "name": "古早味排骨"},
            {"id": "ce48b35e-0178-4404-c08d-08d8b7b80710", "maxImage": "https://www.8way.com.tw/8WayApi/document/6b6ca645-a8e8-4f02-88a2-61791203fc78.png", "minImage": null, "name": "燉蘿蔔"},
            {"id": "ce48b35e-0178-4404-c08d-08d8b7b80703", "maxImage": "https://www.8way.com.tw/8WayApi/document/d655ae66-3a7a-479b-9098-1071a8aec2d0.png", "minImage": null, "name": "和風秋葵"},
            {"id": "8467e2d4-7765-401a-7cc7-08de2678fb9d", "maxImage": "https://www.8way.com.tw/8WayApi/document/cefa64a1-8ca1-4fa4-824a-b8e2e5e8f7ef.jpg", "minImage": null, "name": "皮蛋豆腐"},
            {"id": "ce48b35e-0178-4404-c08d-08d8b7b80711", "maxImage": "https://www.8way.com.tw/8WayApi/document/0f4adf6a-4049-4409-8a08-3731ba9a0057.png", "minImage": null, "name": "燙青菜"},
            {"id": "ce48b35e-0178-4404-c08d-08d8b7b80709", "maxImage": "https://www.8way.com.tw/8WayApi/document/cd29c29f-448f-45f5-b3b6-81e68574ed4d.png", "minImage": null, "name": "黃金豆腐"},
            {"id": "ce48b35e-0178-4404-c08d-08d8b7b80701", "maxImage": "https://www.8way.com.tw/8WayApi/document/cae5067b-efb4-41e9-bb36-ed2e18b064da.png", "minImage": null, "name": "滷蛋"},
            {"id": "ce48b35e-0178-4404-c08d-08d8b7b80705", "maxImage": "https://www.8way.com.tw/8WayApi/document/096a4c41-e735-48de-889c-e3ea63d98979.png", "minImage": null, "name": "黃金泡菜"},
            {"id": "ce48b35e-0178-4404-c08d-08d8b7b80704", "maxImage": "https://www.8way.com.tw/8WayApi/document/de162a26-d4c3-4431-80eb-f2351700ba40.png", "minImage": null, "name": "薄鹽毛豆"},
            {"id": "ce48b35e-0178-4404-c08d-08d8b7b80708", "maxImage": "https://www.8way.com.tw/8WayApi/document/ba9973c3-740f-417d-bdd5-e5c9085ad0b1.png", "minImage": null, "name": "脆筍"},
            {"id": "ce48b35e-0178-4404-c08d-08d8b7b80712", "maxImage": "https://www.8way.com.tw/8WayApi/document/20db85d2-d092-4d86-802d-f5217b8d35b7.png", "minImage": null, "name": "豬頭皮絲"}
          ],
          '0210': [
            {"id": "ce48b35e-0178-4404-c08d-08d8b7b80901", "maxImage": "https://www.8way.com.tw/8WayApi/document/38472970-2008-4c6f-bf7b-b8bc255abcc2.jpg", "minImage": "https://www.8way.com.tw/8WayApi/document/b1177dce-8afa-49fa-809f-3852473a77a6.jpg", "name": "香濃豆漿"},
            {"id": "ce48b35e-0178-4404-c08d-08d8b7b80902", "maxImage": "https://www.8way.com.tw/8WayApi/document/55a790c1-f0de-4051-9422-0e313950b5ed.jpg", "minImage": "https://www.8way.com.tw/8WayApi/document/cda2b7a7-053b-47e3-aec2-220d54585108.jpg", "name": "香濃豆漿(無加糖)"},
            {"id": "ce48b35e-0178-4404-c08d-08d8b7b80903", "maxImage": "https://www.8way.com.tw/8WayApi/document/12e26c92-e373-4029-afee-9712cb4b46fd.jpg", "minImage": "https://www.8way.com.tw/8WayApi/document/d523f184-17d7-4610-806b-59af15a66b37.jpg", "name": "黑豆漿"},
            {"id": "ce48b35e-0178-4404-c08d-08d8b7b80904", "maxImage": "https://www.8way.com.tw/8WayApi/document/8a1692c1-dab1-45bf-abdb-52a4a2545889.jpg", "minImage": "https://www.8way.com.tw/8WayApi/document/caf9e6e1-5cf3-477e-b55b-4e83b043d1cb.jpg", "name": "真傳特調紅茶"}
          ],
          '0211': [
            {"id": "ce48b35e-0178-4404-c08d-08d8b7b80801", "maxImage": "https://www.8way.com.tw/8WayApi/document/b514a8b0-5552-4fd7-8e42-83797093eb40.png", "minImage": "https://www.8way.com.tw/8WayApi/document/8723c956-8321-4d4f-a45b-9cb0318b3322.png", "name": "招牌生水餃"},
            {"id": "ce48b35e-0178-4404-c08d-08d8b7b80802", "maxImage": "https://www.8way.com.tw/8WayApi/document/b5027fd2-b646-4440-9927-fa1ef05b32b5.png", "minImage": "https://www.8way.com.tw/8WayApi/document/48dfca64-b409-412c-b298-b3b47b9786b5.png", "name": "韭菜生水餃"},
            {"id": "ce48b35e-0178-4404-c08d-08d8b7b80803", "maxImage": "https://www.8way.com.tw/8WayApi/document/eabdb183-09d9-423e-a271-504b10b304b2.png", "minImage": "https://www.8way.com.tw/8WayApi/document/1c7f3cf0-704e-4e2c-b60b-5a5b2660480a.png", "name": "韓式辣味生水餃"},
            {"id": "ce48b35e-0178-4404-c08d-08d8b7b80804", "maxImage": "https://www.8way.com.tw/8WayApi/document/87c02004-0ef1-4919-81c6-bf47f1916474.png", "minImage": "https://www.8way.com.tw/8WayApi/document/def40b98-1759-4fac-aecb-6fefe6374a03.png", "name": "玉米生水餃"},
            {"id": "ce48b35e-0178-4404-c08d-08d8b7b80805", "maxImage": "https://www.8way.com.tw/8WayApi/document/611c2a34-23fd-49d2-93a2-9620c287f825.png", "minImage": "https://www.8way.com.tw/8WayApi/document/526fd085-59da-4717-bd5c-c6232c85fbcd.png", "name": "咖哩生水餃"},
            {"id": "ce48b35e-0178-4404-c08d-08d8b7b80806", "maxImage": "https://www.8way.com.tw/8WayApi/document/0b363d5f-1d4f-4a08-82f7-7c1f0a00df14.png", "minImage": "https://www.8way.com.tw/8WayApi/document/793bf933-e82c-47fd-9cf3-c086301034dc.png", "name": "鮮蝦生水餃"},
            {"id": "ce48b35e-0178-4404-c08d-08d8b7b80808", "maxImage": "https://www.8way.com.tw/8WayApi/document/596ebda4-f949-45a4-84b1-2a1ffbe5a7ac.png", "minImage": "https://www.8way.com.tw/8WayApi/document/a287b1e6-d74a-4b55-95e5-e8f39aa423af.jpg", "name": "新蔬食生水餃"},
            {"id": "ce48b35e-0178-4404-c08d-08d8b7b80809", "maxImage": "https://www.8way.com.tw/8WayApi/document/583fbfdf-f3a8-4bef-bc34-0576c83bca20.png", "minImage": "https://www.8way.com.tw/8WayApi/document/a2d3318f-0c5e-4a77-99b4-18b7bb6447fc.png", "name": "珍珠生餛飩"},
            {"id": "ce48b35e-0178-4404-c08d-08d8b7b80810", "maxImage": "https://www.8way.com.tw/8WayApi/document/f61ba247-6e7f-46fc-bc5a-5723e29f5086.png", "minImage": "https://www.8way.com.tw/8WayApi/document/708760b1-f255-474a-afb3-78ef0ede2eb5.png", "name": "菜肉大生餛飩"}
          ]
        },
       baseUrl: 'https://www.8way.com.tw',
       ogTitle : '',
       ogDescription : '',
       ogImage : '',
       schemaData : null,
       id :this.$route.params.ids,
       seoDescription : '',  //SEO後台文案  
       schemaData: null,

      }
    },

    metaInfo() {
      // const baseUrl = 'https://www.8way.com.tw';
      // let ogTitle = '';
      // let ogDescription = '';
      // let ogImage = '';
      // let schemaData = null;
      // let id = this.$route.params.ids;
      // let seoDescription  = '';  //SEO後台文案
      
      return {
        title: this.seoDescriptionTitle,
        meta: [
        //  SEO 用（搜尋引擎）
           {
             vmid:  "description", name: "description",
             content: this.seoDescription  
           },
          { vmid:'og:title', property: 'og:title', content: this.ogTitle },
          { vmid:'og:description', property: 'og:description', content: this.ogDescription },
          { vmid:'og:image', property: 'og:image', content: this.ogImage },
          { property: 'og:url', content: window.location.href },
          { property: 'og:type', content: 'website' }
        ],
        script: this.schemaData ? [
          {
            type: 'application/ld+json',
            json: this.schemaData
          }
        ] : []
      }
    },

    afterRouteEnter (to, from, next) {
      // 在路由進入後執行
      this.paramId = to.params.id;
      // console.log("afterRouteEnter paramId:", this.paramId);
      this.getMetaInfo(this.paramId);
      next();
    },

    mounted () {
      this.locale=sessionStorage.getItem('lang');
      this.paramId = this.$route.params.id;
      this.GetTypeList();
      this.getMetaInfo(this.paramId);
    },


    methods:{
      tabtitle(id, name, img, nameEN){
        this.$router.push({ name: 'Product', params: { id: id }});
        this.paramId = id;
        this.name = name;
        this.bannerImage = img;
        this.nameEN = nameEN;
        this.GetTypeList();
      }, /*側邊攔*/ 

      changeType(e){
        const [ choose ] = this.typeList.filter((item) => { return this.paramId === item.id });
        this.tabtitle(choose.id, choose.name, choose.bannerImage, choose.nameEN);
      },  /*側邊攔*/ 


      GetTypeList:function(){
        this.$fetch(API.getProductType).then((response) => {
          if(response.code === 200){
            this.typeList = response.data;
            if(this.paramId){
              this.typeList.forEach(item => {
                if(this.paramId === item.id){
                  this.name = item.name;
                  this.nameEN = item.nameEN;
                  this.bannerImage = item.bannerImage;

                if (item.name === "鍋貼系列") {
                   this.descriptionTitle = this.$t("home_59"); // 對應 home_60
                   this.descriptionSubtitle = this.$t("home_60"); // 對應 home_61
                   this.descriptionContent = this.$t("home_61"); // 對應 home_62
                   }
                else if (item.name === "水餃系列") {
                   this.descriptionTitle = this.$t("home_62"); // 對應 home_63
                   this.descriptionSubtitle = this.$t("home_63"); // 對應 home_64
                   this.descriptionContent = this.$t("home_64"); // 對應 home_65
                   }
                else if (item.name === "乾麵系列") {
                   this.descriptionTitle = this.$t("home_65"); // 對應 home_66
                   this.descriptionSubtitle = this.$t("home_66"); // 對應 home_67
                   this.descriptionContent = this.$t("home_67"); // 對應 home_68
                   }  
                else if (item.name === "湯麵系列") {
                   this.descriptionTitle = this.$t("home_68"); // 對應 home_69
                   this.descriptionSubtitle = this.$t("home_69"); // 對應 home_70
                   this.descriptionContent = this.$t("home_70"); // 對應 home_71
                   }  
                else if (item.name === "湯品系列") {
                   this.descriptionTitle = this.$t("home_71"); // 對應 home_72
                   this.descriptionSubtitle = this.$t("home_72"); // 對應 home_73
                   this.descriptionContent = this.$t("home_73"); // 對應 home_74
                   }
                else if (item.name === "湯餃系列") {
                   this.descriptionTitle = this.$t("home_74"); // 對應 home_75
                   this.descriptionSubtitle = this.$t("home_75"); // 對應 home_76
                   this.descriptionContent = this.$t("home_76"); // 對應 home_77
                   }
                else if (item.name === "抄手系列") {
                   this.descriptionTitle = this.$t("home_77"); // 對應 home_78
                   this.descriptionSubtitle = this.$t("home_78"); // 對應 home_79
                   this.descriptionContent = this.$t("home_79"); // 對應 home_80
                   }
                else if (item.name === "小菜系列") {
                   this.descriptionTitle = this.$t("home_80"); // 對應 home_81
                   this.descriptionSubtitle = this.$t("home_81"); // 對應 home_82
                   this.descriptionContent = this.$t("home_82"); // 對應 home_83
                   }
                else if (item.name === "飲品系列") {
                   this.descriptionTitle = this.$t("home_83"); // 對應 home_84
                   this.descriptionSubtitle = this.$t("home_84"); // 對應 home_85
                   this.descriptionContent = this.$t("home_85"); // 對應 home_86
                   }
                else if (item.name === "生鮮冷凍系列") {
                   this.descriptionTitle = this.$t("home_86"); // 對應 home_87
                   this.descriptionSubtitle = this.$t("home_87"); // 對應 home_88
                   this.descriptionContent = this.$t("home_88"); // 對應 home_89
                   }
                else if (item.name === "金牌牛肉產品系列") {
                   this.descriptionTitle = this.$t("home_89"); // 對應 home_90
                   this.descriptionSubtitle = this.$t("home_90"); // 對應 home_91
                   this.descriptionContent = this.$t("home_91"); // 對應 home_92
                   }
                else {
                   this.descriptionTitle = ""; 
                   this.descriptionSubtitle = ""; 
                   this.descriptionContent = "";    
                }
              } });
            }else {
              const [ type = {} ] = this.typeList;
              this.paramId = type.id;
              this.name = type.name;
              this.bannerImage = type.bannerImage;
              this.nameEN = type.nameEN;
            }
            this.GetProductList();
          }
        });
      },

      GetProductList:function(){
        this.$post(API.getProductList,{
          "typeId": this.paramId
        }).then((response) => {
          if(response.code === 200){
            this.productList = response.data;
          }
        });
      },

      toDetail: function (id){
        this.$router.push({ name: 'ProductDetails', params: { id: id }});
      },

      getMetaInfo: function(id) {    
        switch(id){
        case '0201':
          this.ogTitle = '八方雲集 - 鍋貼系列 Pot Stickers';
          this.ogDescription = '品嚐八方雲集招牌鍋貼系列,外皮酥脆、內餡飽滿,共有6種口味任您選擇。';
          this.ogImage = 'https://www.8way.com.tw/assets/images/ogImg_home.jpg';
          this.seoDescription  = '八方雲集鍋貼系列以特選肉品與契作高麗菜入餡，推出招牌、韭菜、韓式辣味、玉米、咖哩，以及新蔬食(無肉)鍋貼等多種口味，外酥內嫩、香氣四溢，每一口都是經典';
          this.seoDescriptionTitle = '八方雲集鍋貼系列｜招牌、韭菜、韓式辣味、玉米、咖哩、新蔬食鍋貼';
          this.schemaData = {
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            "name": "八方雲集鍋貼系列",
            "description": "八方雲集招牌鍋貼,皮薄餡香,煎得金黃酥脆,提供多種口味選擇。",
            "url": `${this.baseUrl}/Product/0201`,
            "mainEntity": {
              "@type": "ItemList",
              //"itemListElement": this.getItemListElement()
            }
          };
          break;
        case '0202':
          this.ogTitle = '八方雲集 - 水餃系列 Boiled Dumplings';
          this.ogDescription = '新鮮現煮水餃,皮薄餡多、口感Q彈,7種經典口味滿足您的味蕾。';
          this.ogImage = 'https://www.8way.com.tw/assets/images/ogImg_home.jpg';
          this.seoDescription  = '八方雲集水餃系列嚴選契作高麗菜與特選肉品，推出招牌、韭菜、韓式辣味、玉米、咖哩、鮮蝦與新蔬食(無肉)水餃口味；冷凍水餃同步販售，隨時在家烹煮，讓美味不受限';
          this.seoDescriptionTitle = '八方雲集水餃系列｜招牌、韭菜、韓式辣味、鮮蝦等口味與冷凍水餃';          
          this.schemaData = {
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            "name": "八方雲集水餃系列",
            "description": "八方雲集水餃系列,手工包製,皮Q餡鮮,多種口味選擇。",
            "url": `${this.baseUrl}/Product/0202`,
            "mainEntity": {
              "@type": "ItemList",
              //"itemListElement": this.getItemListElement()
            }
          };
          break;
        case '0204':
          this.ogTitle = '八方雲集 - 乾麵系列 Noodles with Sauce';
          this.ogDescription = '濃郁醬香配上Q彈麵條,4種乾麵口味讓您回味無窮。';
          this.ogImage = 'https://www.8way.com.tw/assets/images/ogImg_home.jpg';
          this.seoDescription  = '八方雲集乾麵系列以現煮麵條搭配多款經典醬料，古早味乾麵的油蔥香、招牌乾麵的微辣濃香、麻醬乾麵的芝麻滑順、紹辣乾麵的川味麻辣，層層堆疊，展現八方雲集職人級的講究';
          this.seoDescriptionTitle = '八方雲集乾麵系列｜古早味、招牌、麻醬、紹辣乾麵等各式經典風味';            
          this.schemaData = {
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            "name": "八方雲集乾麵系列",
            "description": "八方雲集乾麵系列,麵條Q彈有勁,醬料濃郁美味。",
            "url": `${this.baseUrl}/Product/0204`,
            "mainEntity": {
              "@type": "ItemList",
              //"itemListElement": this.getItemListElement()
            }
          };
          break;
        case '0205':
          this.ogTitle = '八方雲集 - 湯麵系列 Noodle Soup';
          this.ogDescription = '暖心湯麵,湯頭濃郁、麵條Q彈,8種口味溫暖您的胃。';
          this.ogImage = 'https://www.8way.com.tw/assets/images/ogImg_home.jpg';
          this.seoDescription  = '八方雲集湯麵系列以嚴選食材熬製湯頭，呈現麵條的多樣風味，梁師傅排骨麵濃郁香醇、餛飩麵滑順鮮甜、紹辣湯麵香麻帶勁、古早味湯麵樸實懷舊，每一碗都蘊含了用心熬煮的溫度';
          this.seoDescriptionTitle = '八方雲集湯麵系列｜梁師傅排骨麵、餛飩麵、紹辣湯麵、古早味湯麵';             
          this.schemaData = {
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            "name": "八方雲集湯麵系列",
            "description": "八方雲集湯麵系列,湯頭鮮美,麵條彈牙,多種口味選擇。",
            "url": `${this.baseUrl}/Product/0205`,
            "mainEntity": {
              "@type": "ItemList",
              //"itemListElement": this.getItemListElement()
            }
          };
          break;
        case '0212':
          this.ogTitle = '八方雲集 - 金牌牛肉產品系列 BaFang Beef Meals';
          this.ogDescription = '嚴選優質牛肉,鮮嫩多汁,12種金牌牛肉美食等您品嚐。';
          this.ogImage = 'https://www.8way.com.tw/assets/images/ogImg_home.jpg';
          this.seoDescription  = '八方雲集金牌牛肉系列以嚴選牛肉與慢火湯頭展現紅燒、清燉、麻辣三大風味，推出牛肉麵、湯餃、餛飩等多樣選擇，部分門市還提供冬粉品項，展現職人熬煮的經典味道';
          this.seoDescriptionTitle = '八方雲集金牌牛肉系列｜紅燒、清燉、麻辣牛肉麵與冬粉、湯餃、餛飩';              
          this.schemaData = {
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            "name": "八方雲集金牌牛肉系列",
            "description": "八方雲集金牌牛肉系列,嚴選優質牛肉,鮮嫩多汁。",
            "url": `${this.baseUrl}/Product/0212`,
            "mainEntity": {
              "@type": "ItemList",
              //"itemListElement": this.getItemListElement()
            }
          };
          break;
        case '0206':
          this.ogTitle = '八方雲集 - 湯品系列 Soup';
          this.ogDescription = '鮮美營養的湯品系列,6種口味溫暖您的心。';
          this.ogImage = 'https://www.8way.com.tw/assets/images/ogImg_home.jpg';
          this.seoDescription  = '八方雲集湯品系列精選食材細火熬煮，推出酸辣湯、玉米濃湯、蘿蔔湯、旗魚花枝丸湯、珍珠餛飩湯與菜肉大餛飩湯等選擇。酸香、甘甜、鮮美層層堆疊，溫潤湯頭喚醒味蕾';
          this.seoDescriptionTitle = '八方雲集湯品系列｜酸辣湯、玉米濃湯、蘿蔔湯、餛飩湯等暖心美味';            
          this.schemaData = {
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            "name": "八方雲集湯品系列",
            "description": "八方雲集湯品系列,鮮美營養,多種口味滿足您的需求。",
            "url": `${this.baseUrl}/Product/0206`,
            "mainEntity": {
              "@type": "ItemList",
              //"itemListElement": this.getItemListElement()
            }
          };
          break;
        case '0207':
          this.ogTitle = '八方雲集 - 湯餃系列 Dumplings with Soup';
          this.ogDescription = '水餃配湯頭,雙重美味一次滿足,2種經典口味。';
          this.ogImage = 'https://www.8way.com.tw/assets/images/ogImg_home.jpg';
          this.seoDescription  = '八方雲集湯餃系列以現煮水餃搭配熱湯，讓湯香與餡香在口中交融。酸辣湯餃以酸香湯汁包覆多汁肉餡；玉米湯餃則讓濃郁甜湯與餃子湯汁相互滲透。每一碗都是完美契合的美味體驗';
          this.seoDescriptionTitle = '八方雲集湯餃系列｜酸辣湯餃、玉米湯餃，雙重搭配經典登場';
          this.schemaData = {
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            "name": "八方雲集湯餃系列",
            "description": "八方雲集湯餃系列,水餃配湯頭,雙重美味一次滿足。",
            "url": `${this.baseUrl}/Product/0207`,
            "mainEntity": {
              "@type": "ItemList",
              //"itemListElement": this.getItemListElement()
            }
          };
          break;
        case '0208':
          this.ogTitle = '八方雲集 - 抄手系列 Wontons with Sauce';
          this.ogDescription = '皮薄餡嫩的抄手系列,4種口味讓您欲罷不能。';
          this.ogImage = 'https://www.8way.com.tw/assets/images/ogImg_home.jpg';
          this.seoDescription  = '八方雲集抄手系列嚴選珍珠與菜肉兩款餛飩，搭配和風醬或紅油醬汁，呈現清爽與辛香兩種滋味。薄皮包餡滑順細緻，紅油香氣與和風甘醇交織，每一口都能嚐到抄手的鮮香美味';
          this.seoDescriptionTitle = '八方雲集抄手系列｜和風抄手、紅油抄手，珍珠與菜肉雙款經典';          
          this.schemaData = {
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            "name": "八方雲集抄手系列",
            "description": "八方雲集抄手系列,皮薄餡嫩,醬汁香濃。",
            "url": `${this.baseUrl}/Product/0208`,
            "mainEntity": {
              "@type": "ItemList",
              //"itemListElement": this.getItemListElement()
            }
          };
          break;
        case '0209':
          this.ogTitle = '八方雲集 - 小菜系列 Side Dishes';
          this.ogDescription = '豐富多樣的小菜系列,14種選擇為您的餐點增添風味。';
          this.ogImage = 'https://www.8way.com.tw/assets/images/ogImg_home.jpg';
          this.seoDescription  = '八方雲集小菜系列精選多款經典台式風味，皮蛋豆腐滑嫩清香、豆香與蛋香交融，涼拌豆腐三款風味香氣各異，古早味排骨酥香鮮嫩，黃金豆腐與滷蛋滷香濃郁，泡菜爽口開胃';
          this.seoDescriptionTitle = '八方雲集小菜系列｜皮蛋豆腐、黃金豆腐、古早味排骨、泡菜、滷蛋';                  
          this.schemaData = {
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            "name": "八方雲集小菜系列",
            "description": "八方雲集小菜系列,豐富多樣,為您的餐點增添風味。",
            "url": `${this.baseUrl}/Product/0209`,
            "mainEntity": {
              "@type": "ItemList",
              //"itemListElement": this.getItemListElement()
            }
          };
          break;
        case '0210':
          this.ogTitle = '八方雲集 - 飲品系列 Drinks';
          this.ogDescription = '清涼解渴的飲品系列,4種選擇為您的餐點畫下完美句點。';
          this.ogImage = 'https://www.8way.com.tw/assets/images/ogImg_home.jpg';
          this.seoDescription  = '八方雲集飲品系列嚴選非基因改造黃豆與優質紅茶，推出香濃豆漿、無加糖豆漿、黑豆漿與真傳特調紅茶。豆香濃郁、茶香多層，甜而不膩，清爽解膩，是搭配餐點的絕佳選擇';
          this.seoDescriptionTitle = '八方雲集飲品系列｜豆漿、黑豆漿、真傳特調紅茶，餐點絕配飲品';             
          this.schemaData = {
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            "name": "八方雲集飲品系列",
            "description": "八方雲集飲品系列,清涼解渴,多種選擇。",
            "url": `${this.baseUrl}/Product/0210`,
            "mainEntity": {
              "@type": "ItemList",
              //"itemListElement": this.getItemListElement()
            }
          };
          break;
        case '0211':
          this.ogTitle = '八方雲集 - 生鮮冷凍系列 Uncooked Dumplings & Wontons';
          this.ogDescription = '新鮮急凍鎖住美味,9種產品讓您在家也能享用八方美食。';
          this.ogImage = 'https://www.8way.com.tw/assets/images/ogImg_home.jpg';
          this.seoDescription  = '八方雲集生鮮冷凍系列嚴選新鮮食材，推出多款生水餃與生餛飩，包括招牌、韭菜、韓式辣味、玉米、咖哩、鮮蝦、新蔬食等口味。冷凍保存方便、加熱即享，輕鬆重現美味';
          this.seoDescriptionTitle = '八方雲集生鮮冷凍系列｜多款生水餃、生餛飩，冷凍保存在家輕鬆享';            
          this.schemaData = {
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            "name": "八方雲集生鮮冷凍系列",
            "description": "八方雲集生鮮冷凍系列,新鮮急凍,鎖住美味。",
            "url": `${this.baseUrl}/Product/0211`,
            "mainEntity": {
              "@type": "ItemList",
              //"itemListElement": this.getItemListElement()
            }
          };
          break;
        default:
          this.seoDescription  = '八方雲集餐點以安心為理念，呈現多款經餐點系列，包括鍋貼、水餃、麵食、湯品、小菜、金牌牛肉及生鮮冷凍等選擇，呈現八方雲集菜單的豐富樣貌，以最熟悉的風味陪伴每一餐';
          this.seoDescriptionTitle = '八方雲集安心餐點｜鍋貼、水餃、麵食等多款系列，八方菜單一次看';
          this.ogTitle = '八方雲集 - 產品系列';
          this.ogDescription = '多樣化的美食產品,滿足您的味蕾需求。';
          this.ogImage = 'https://www.8way.com.tw/assets/images/ogImg_home.jpg';
      }
      // console.log(this.ogTitle, this.ogDescription, this.ogImage);
      },

    },

    // watch: {
    //   $route: {
    //     handler() {
    //       this.paramId = this.$route.params.ids;
    //       this.GetTypeList(); 
    //       this.$nextTick(() => {
    //             this.$meta().refresh();
    //           });
    //     },
    //     deep: true,
    //   }
    // },
    components:{
      'vue-tab-select': vueTabSelect
    },

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .description{
    //margin-top: 27px;
    height: auto;
    ///max-width: 718px;
    border-radius: 30px;
    background-color: #FFFFFF;
    box-shadow: 0 10px 20px 0 rgba(0,0,0,0.05);
    padding: 20px 20px 20px 20px;
    //margin-left: 22px;
             }

  .description h2 {
      font-size: 20px;
      line-height: 2; 
       letter-spacing: 1.5px;
    }
  .description h1 {
      font-size: 24px;
      font-weight: bold;  
    }

  ul{
    padding-left:0;
  }
  .product{
    width: 100%;
    height:auto;
    background:#fafafa;
 /*  .top-img{
     width: 100%;
     height: 354px;
     position: relative;
     background:#fafafa url("../assets/images/product-banner.png") no-repeat top;
     background-size: 100% 100%;;
     .bg-img{
       position: absolute;
       width: 100%;
     }
     img{
      !* width: 100%;
       height: 100%;
       background-size: cover;*!
     }
     .info-box{
       width: 100%;
       max-width: 1392px;
       padding: 0 20px 0 9.339%;
       margin: 0 auto;
       &:after{
         content: "";
         display: block;
         clear: both;
       }
       .title-box{
         max-width: 54%;
         float: left;
         padding-top: 60px;
         text-align: right;
         h2{
           color: #FFFFFF;
           font-size: 68px;
           font-style: italic;
           font-weight: 900;
           letter-spacing: 0;
           line-height: 75px;
           margin-bottom: 15px;
         }
         h3{
           color: #FFFFFF;
           font-size: 36px;
           letter-spacing: 1px;
           line-height: 42px;
           margin: 0;
         }
       }
       .bannerImage{
         float: right;
         width: 46%;
         padding-top: 25px;
         img{
           width: 100%;
         }
       }
     }
   }*/
  .bannerImage{
    width: 30%;
 /*   padding-top: 25px;
    float: right;*/
    position: absolute;
    right:15%;
    bottom:-5px;
       img{
         width: 100%;
       }
  }

  .product-main{
    width: 100%;
    height: 100%;
    background: #f9f9f9 url("../assets/images/product-contenBg.png") no-repeat center 100px;
    background-size: 100% auto;
    overflow: hidden;
    padding-top: 36px;
    padding-bottom: 140px;
  }
   .product-conten{
     max-width:1390px;
     padding: 0 20px;
     margin: 0 auto;
    .product-title{
      padding-bottom:40px;
      font-size: 14px;
      letter-spacing: 1.5px;
      text-align: left;
       a{
         color: #000;
         text-decoration: underline;
       }
      em{
        padding: 0 4px;
      }
      span,em{
        color: #9A928D;
      }
    }
    .nav{
      height: auto;
      width: 350px;
      border-radius: 20px;
      background-color: #FFFFFF;
      box-shadow: 0 10px 20px 0 rgba(0,0,0,0.05);
      padding:55px 48px 55px 44px;
      position: relative;
      float: left;
      h4,ul{
       width: 100%;
      }
      h4{
        font-size: 28px;
        font-weight: 500;
        letter-spacing: 2.1px;
        padding-bottom:8px;
      &.en-font-28{
         letter-spacing: 0px;
         font-family: 'Roboto Medium';
       }
      }
      a{
        color: #000;
        font-size: 18px;
        letter-spacing: 1.35px;
        cursor: pointer;
        display: block;
        &.active{
            color:red
          }
        &.en-font-18{
           letter-spacing: 0px;

         }
      }
     ul{
       li{
         padding: 25px 0;
         border-bottom:1px solid #e2e2e2;
         position: relative;
       }
     }
    .active{
      color: #CF0902;
      font-weight: 500;
      a{
        color: #CF0902;
      }
      .nav-line{
        height: 5px;
        width: 46px;
        display: inline-block;
        background-color: #CF0902;
        position: absolute;
        right: -63px;
        top: 36px;
      }
    }
      li:hover{
        color: #CF0902;
        font-weight: 500;
        a{
          color: #CF0902;
        }
      }
    }

   }

    .product-show {
      width: calc(100% - 350px);
      height: auto;
      float: left;
      padding-left: 124px;

      ul {
        padding-left: 0;

        li {
          width: calc( (100% - 180px ) / 3);
          float: left;
          cursor: pointer;
          margin: 0 36px 50px;
          .img-box{
            position: relative;
          }
          .big-img-box {
            width: 100%;
            border-radius: 50%;
            border: 8px solid #fff;
            overflow: hidden;
            box-shadow: 0 5px 10px 0 rgba(0,0,0,0.05);
            img {
              width: 100%;
              height: 100%;
              background-size: 100%;
            }
          }
          .small-img-box{
            width: 66px;
            height: 66px;
            border: solid 3px #fff;
            border-radius: 50%;
            overflow: hidden;
            background: #fff;
            position: absolute;
            right: 0;
            bottom: 19px;
            box-shadow: 0 5px 10px 0 rgba(0,0,0,0.05);
            img{
              width: 100%;
            }
          }

          p {
            text-align: center;
            padding-top: 10px;
            font-size: 18px;
            letter-spacing: 0.9px;
            line-height: 42px;
            color: #000;
          }
          &:nth-child(3n + 1){
            clear: both;
          }
          &:nth-child(3n){
            margin-right: 0;
          }
        }
      }
    }
  }
  @media (max-width:1080px){
    .type-nav{
      margin-top: 10px;
    }
    .product{
      .product-main{
        background-image: url("../assets/images/product-bg-mobile.png");
      }
      .top-img{
        height: 187px;
        background-image: url("../assets/images/product-banner-mobile.png");
        background-size: 100% auto;
        background-color: #f9f9f9;
        background-repeat: no-repeat;
        .info-box{
          position: relative;
          height: 100%;
          .title-box{
            padding-top: 20px;
            position: static;
            float: left;
            h2{
              font-size: 24px;
              letter-spacing: 0;
              line-height: 28px;
              margin-bottom: 9px;

            }
            h3{
              font-size: 20px;
              letter-spacing: 0.56px;
              line-height: 28px;
            }
          }
          .bannerImage{
            width: auto;
            height: 66%;
            position: absolute;
            bottom: 12px;
            right: 20px;
            text-align: right;
            img{
              width: auto;
              height: 100%;
            }
          }
        }
      }
       .product-main{
         padding:0 20px;
         padding-top: 20px;

       }
       .product-conten{
         padding: 0;
         .product-title{
           padding-bottom: 20px;
         }
       }

     .product-show{
       width: 100%;
       padding: 30px 0;
       ul{
         padding: 0 5px;
         li{
           width: 50%;
           padding: 0 25px;
           margin: 0 0 25px 0;
           .img-box{
             margin-bottom: 2px;
           }
           .big-img-box{
             border-width: 5px;
             width: 100%;
             margin: 0;
           }
           p{
             font-size: 15px;
             letter-spacing: 0.5px;
             line-height: 28px;
             padding-top: 0;
           }
           &:nth-child(3n+1) {
             clear: inherit;
           }
           &:nth-child(2n+1) {
             clear: both;
           }
         }
       }
     }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/product.vue